import { QUERY_PARAM_DRAFT_OMSID, Utils } from './urlUtils';

/* globals featureGates */
const isDraft = !!Utils.getParameterByName(QUERY_PARAM_DRAFT_OMSID);
const ssr = typeof window === 'undefined';

export const getFeatureGates = () => {
  if (ssr) return null;

  return {
    ...window?.featureGates,
    enableSaveAndContinue: window?.featureGates?.enableSaveAndContinue && !isDraft,
    isDraft,
  };
};
